import { render, staticRenderFns } from "./modify-pwd.vue?vue&type=template&id=4072e9ee&scoped=true&"
import script from "./modify-pwd.vue?vue&type=script&lang=ts&"
export * from "./modify-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./modify-pwd.vue?vue&type=style&index=0&id=4072e9ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072e9ee",
  null
  
)

export default component.exports